import ZoomVideoSDK from "@zoom/videosdk";
import { LocalAudioDelegator } from "../../../../core/room/participant/media/MediaDelegator";
import { LocalAudioTrack } from "../../../types";

/**
 * Preview delegator for Zoom's LocalAudioTrack, used before joining a session.
 * Unlike video, audio preview doesn't require an element, but we provide this
 * delegator for consistency and to encapsulate the preview track lifecycle.
 */
export class ZoomLocalPreviewAudioDelegator implements LocalAudioDelegator {
  readonly kind = "audio" as const;
  #track: LocalAudioTrack;
  #deviceId: string;
  #enabled: boolean;

  static async create(deviceId: string, enabled: boolean) {
    const previewAudioTrack = ZoomVideoSDK.createLocalAudioTrack(deviceId);
    // connnects to Zoom's hidden audio element and starts muted
    await previewAudioTrack.start();

    if (enabled) {
      await previewAudioTrack.unmute();
    }

    return new ZoomLocalPreviewAudioDelegator(
      previewAudioTrack,
      deviceId,
      enabled,
    );
  }

  constructor(track: LocalAudioTrack, deviceId: string, enabled: boolean) {
    this.#track = track;
    this.#deviceId = deviceId;
    this.#enabled = enabled;
  }

  get deviceId() {
    return this.#deviceId;
  }

  get isEnabled() {
    return this.#enabled;
  }

  // non-interface methods

  get track() {
    return this.#track;
  }
}
